import { useCallback, useEffect, useState } from 'react';
import { boardService } from '../services/boardService';

export const CLUB_BOARD_READ_EVENT = 'yona:club-board-read';

/**
 * Poll club board unread counts for nav + club detail tab badges.
 */
export function useClubBoardUnread({ enabled = true, pollMs = 15000 } = {}) {
  const [unreadTotal, setUnreadTotal] = useState(0);
  const [byClub, setByClub] = useState({});

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const data = await boardService.getUnreadSummary();
      setUnreadTotal(Number(data?.unread_total) || 0);
      setByClub(data?.by_club && typeof data.by_club === 'object' ? data.by_club : {});
    } catch {
      // ignore — badges are best-effort
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setUnreadTotal(0);
      setByClub({});
      return undefined;
    }
    refresh();
    const onRead = () => {
      refresh();
    };
    window.addEventListener(CLUB_BOARD_READ_EVENT, onRead);
    const intervalId = setInterval(refresh, pollMs);
    return () => {
      window.removeEventListener(CLUB_BOARD_READ_EVENT, onRead);
      clearInterval(intervalId);
    };
  }, [enabled, pollMs, refresh]);

  const unreadForClub = useCallback(
    (clubId) => {
      if (clubId == null || clubId === '') return 0;
      return Number(byClub[String(clubId)]) || 0;
    },
    [byClub]
  );

  return { unreadTotal, byClub, unreadForClub, refresh };
}

export function notifyClubBoardRead() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CLUB_BOARD_READ_EVENT));
  }
}
